<template>
    <div>
        <Table ref="table" :no-data-text="$t('common.noData')" :columns="columns" :loading="modalLoading" :data="querySlbByGroupIdList" style="width: 100.1%;">
            <template slot-scope="{row,index}" slot="actions">
                <span @click="doDelete(index)">
                    <Button type="error" size="small" @click="slbDelmodal = true">{{ $t('alarms.common.delete') }}</Button>
                </span>
            </template>
        </Table>
        <br>

        <Modal v-model="slbDelmodal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
            </p>
            <div style="text-align:center">
                <p>{{ $t('alarms.common.sureDelete') }} {{name}} {{ $t('alarms.common.what') }}?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long @click="deleteSlb()" :disabled="isDisable">{{ $t('alarms.common.delete') }}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    var tableSlb = {}
    export default {
        name: 'TableServerLoadBalancing',
        data() {
            return {
                name: '',
                modalLoading: true,
                slbDelmodal: false,
                isDisable: false,
                columns: [
                {
                    title: this.$t('alarms.network.loadBalancing.name'),
                    key: 'name'
                },
                {
                    title: this.$t('alarms.common.accountName'),
                    key: 'accountName'
                },
                {
                    title: this.$t('alarms.network.loadBalancing.DNSName'),
                    key: 'dnsName'
                },
                {
                    title: 'VPC ID',
                    key: 'vpcId'
                },
                {
                    title: this.$t('alarms.network.loadBalancing.LBType'),
                    key: 'loadbalancerType'
                },
                {
                    title: this.$t('alarms.network.loadBalancing.status'),
                    key: 'stateName'
                },
                {
                    title: this.$t('alarms.network.loadBalancing.region'),
                    key: 'region'
                },
                {
                    title: this.$t('common.operation'),
                    slot: 'actions'
                }],
                querySlbByGroupIdList: []
            }
        },
        beforeCreate: function () {
            tableSlb = this
        },
        mounted: function () {
            this.queryslbByGroupId();
        },
        methods: {
            // 点击备份目标的时候显示slb列表
            queryslbByGroupId: function () {
                tableSlb.$api.alertRuleExceptionResource.listAlertRuleExceptionResource({
                    "ticketCompanyMonitorItemVariablesId": this.$route.query.id,
                    "monitorModule": this.$route.query.monitorModule
                })
                .then(res => {
                    this.modalLoading = false
                    if(res.data){
                        this.querySlbByGroupIdList = res.data;
                    }else{
                        this.querySlbByGroupIdList=[];
                    }
                })
            },
            // 显示所有数据
            showAllInstance: function () {
                tableSlb.queryslbByGroupId()
            },
            doDelete: function (index) {
                this.lineIndex = index
                this.name = this.querySlbByGroupIdList[index].name
            },
            // 删除instance
            deleteSlb: function () {
                this.isDisable = true // 开始可以点击
                var lineIndex = this.lineIndex
                // 删除slb
                tableSlb.$api.alertRuleExceptionResource.softDelete({
                    "ticketCompanyMonitorItemVariablesId":this.$route.query.id,
                    "resourceId":this.querySlbByGroupIdList[lineIndex].id
                })
                .then(res => {
                    setTimeout(() => {
                        tableSlb.queryslbByGroupId();
                        this.isDisable = false;
                        this.slbDelmodal = false
                        this.$Message.success('删除成功');
                    }, 1000);                    
                })
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/customer_defined_alarm_configuration/exception_resource/slb/TableServerLoadBalancing.vue